export const buildRelativePositionValue = (researchArea: string) => {
  if (researchArea === 'capital_humano') {
    return 0.6;
  }

  if (researchArea === 'condicoes_de_vida') {
    return 0.59
  }

  if (researchArea === 'desenvolvimento_economico') {
    return 0.52
  }

  if (researchArea === 'desenvolvimento_social') {
    return 0.58
  }

  if (researchArea === 'educacao') {
    return 0.44
  }

  if (researchArea === 'infraestrutura') {
    return 0.60;
  }

  if (researchArea === 'institucional') {
    return 0.40;
  }

  if (researchArea === 'juventude') {
    return 0.45;
  }

  if (researchArea === 'saude') {
    return 0.34
  }

  if (researchArea === 'seguranca') {
    return 0.49;
  }
  return 0
};
